import { gql } from '@apollo/client';
import { categoryFragment } from '../../../../graphql/fragments';

export const GET_CATEGORY_FORM_DATA = gql`
    query Category($id: String!) {
        category(id: $id) {
            name
            description
            id
            color
            category {
                id
            }
        }
        categories(categoryType: "parentOnly") {
            ...CategoriesFragment
        }
    }
    ${categoryFragment}

`;

export const GET_CATEGORY_PRODUCTS = gql`
    query ProductsByCategory($categoryId: String!) {
        productsByCategory(categoryId: $categoryId) {
            name
            id
        }
    }
`;

export const GET_CATEGORIES = gql`
    query Categories {
        categories {
            id
            name
            color
            description
            ordering
            category {
                id
            }
        }
        categoriesProductCount{
            categoryId
            productCount
        }
    }
`;

export const GET_CATEGORY_OPTIONS = gql`
    query GetCategoryOptions{
        categories(categoryType: "parentOnly") {
            ...CategoriesFragment
        }
    }
    ${categoryFragment}
`;
